import { render, staticRenderFns } from "./PlansArchived.vue?vue&type=template&id=90a68f66&scoped=true&"
import script from "./PlansArchived.vue?vue&type=script&lang=js&"
export * from "./PlansArchived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a68f66",
  null
  
)

export default component.exports